import angular from "angular";
export class ShowDiscussionsLinkController {

    static $inject = ["$uibModalInstance"];

    constructor(
        $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
    ) {
        let showDiscussionsLinkVm: any = this;
        showDiscussionsLinkVm.ok = function (action: string) {
            $uibModalInstance.close(action);
        }
        showDiscussionsLinkVm.cancel = function () {
            $uibModalInstance.dismiss();
        }
    }
}

angular.module('eCareVault.common.itemCard')
    .controller('ShowDiscussionsLinkController', ShowDiscussionsLinkController);
